import { useCallback, useEffect, useRef, useState } from 'react';

function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export default usePrevious;

export const useScrollTo = (
	ref: React.RefObject<HTMLElement>,
	behavior: ScrollBehavior = "smooth",
	block: ScrollLogicalPosition = "start",
) => {
	const scrollTo = useCallback(() => {
		if (ref.current) {
			ref.current.scrollIntoView({
				behavior,
				block,
			});
		}
	}, [ref, behavior, block]);

	return scrollTo;
};

export const useLocalStorage = (key: string) => {
	const [isError, setIsError] = useState<boolean>(false);

	const setValue = (val: any) => {
		try {
			localStorage.setItem(key, JSON.stringify(val));
		} catch {
			setIsError(true);
		}
	};

	const getValue = (defaultValue: any) => {
		try {
			const item = localStorage.getItem(key);
			return item ? JSON.parse(item) : defaultValue;
		} catch {
			setIsError(true);
		}
	};

	const removeValue = () => {
		try {
			localStorage.removeItem(key);
		} catch {
			setIsError(true);
		}
	};

	useEffect(() => {
		setIsError(false);
	}, []);

	return { setValue, getValue, removeValue, isError };
};


